export default {
	save: "Speichern",
	cancel: "Abbrechen",
	ok: "OK",
	change: "Ändern",
};
